import { createApiConstants } from '@saucelabs/sl-util-redux';


export const NAMESPACE = 'migration-wizard';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_ORG_CSV = `${NAMESPACE}/GET_ORG_CSV`;
export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const SET_TEAMS = `${NAMESPACE}/SET_TEAMS`;
export const SHOW_ERROR = `${NAMESPACE}/SHOW_ERROR`;
export const SUBSCRIBE_TRANSFER_STATUS = 'SUBSCRIBE_TRANSFER_STATUS';
export const UNSUBSCRIBE_TRANSFER_STATUS = 'UNSUBSCRIBE_TRANSFER_STATUS';
export const GET_SUBACCOUNTS = createApiNamespacedConstants('GET_SUBACCOUNTS');
export const GET_TRANSFER_STATUS = createApiNamespacedConstants('GET_TRANSFER_STATUS');
export const TRANSFER_ORGANIZATION = createApiNamespacedConstants('TRANSFER_ORGANIZATION');
